import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@primer/primitives/dist/css/functional/themes/light.css";
import "@primer/primitives/dist/css/functional/themes/dark.css";
import { App } from "./App.jsx";
import { AppTheme } from "./components/AppTheme/AppTheme.jsx";
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/typography.css";
import "./styles/layout.css";

createRoot(document.getElementById("app")).render(
  <StrictMode>
    <AppTheme>
      <App />
    </AppTheme>
  </StrictMode>
);
